import styled from 'styled-components'

export const CheckboxesContainer = styled.div`
  margin-top: 20px;
  margin-left: -9px;
`

export const CheckboxAndLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

export const CheckboxClickableArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  min-width: 48px;
`

export const CheckboxOrange = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1px;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: ${props => props.checked ? props.theme.colors.orange : props.theme.colors.veryLightGray};
  border: ${props => props.checked ? 'none' : '1px solid'};
  border-color: ${props => props.checked ? 'none' : props.theme.colors.lightGray};
  cursor: pointer;
  
  &:before {
    background-color: blue;
  }
  
  &:after {
    background-color: orange;
  }
`

export const CheckboxLabelAndLink = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

export const CheckboxLabel = styled.div`
  height: ${props => props.removeHeight ? 'auto' : '15px'};
  color: ${props => props.theme.textColorPrimary};
  font-size: ${props => props.theme.fontSizeExtraSmall};
`
